import React from "react";
import { Link } from "react-router-dom";
import diverseImage from "../images/comp/diverse-friends-using-digital-devices 3.webp";

const Choose = ({ title, subtitle, items, buttonText, buttonLink, image, imageAlt }) => {
  return (
    <section className="about-servies-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Image */}
          <div className="col-lg-6 mb-4 mb-lg-0 position-relative">
            <img
              src={image || diverseImage}
              alt={imageAlt || "Team"}
              className="img-fluid rounded about-img"
            />
          </div>

          {/* Content */}
          <div className="col-lg-6">
            <h2 className="title mb-3">{title}</h2>
            {items?.map((item, index) => (
              <p className="sub-title" key={index}>
                <span className="about-label-services">{item.label}:</span>{" "}
                {item.text}
              </p>
            ))}

            <Link to={buttonLink} className="btn btn-orange">
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Choose;
